import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  CREATE_BARCODES_REQUESTED,
  CREATE_BARCODES_SUCCESS,
  CREATE_BARCODES_FAILURE,
  CREATE_ALL_BARCODE_IMAGES_REQUESTED,
  CREATE_ALL_BARCODE_IMAGES_SUCCESS,
  CREATE_ALL_BARCODE_IMAGES_FAILURE,
  CREATE_ALL_BARCODE_VALUES_REQUESTED,
  CREATE_ALL_BARCODE_VALUES_SUCCESS,
  CREATE_ALL_BARCODE_VALUES_FAILURE,
  REFRESH_BATCHES_REQUESTED,
  REFRESH_BATCHES_SUCCESS,
  REFRESH_BATCHES_FAILURE,
  DOWNLOAD_BARCODE_IMAGE_REQUESTED,
  DOWNLOAD_BARCODE_IMAGE_SUCCESS,
  DOWNLOAD_BARCODE_IMAGE_FAILURE,
} from '../types';

export const generateBarcodesRequested = () => {
  return {
    type: CREATE_BARCODES_REQUESTED
  }
};

// Watch this watchID to check if barcodes have been generated
export const generateBarcodesSuccess = (payload) => {
  return {
    type: CREATE_BARCODES_SUCCESS,
    payload: payload
  }
};

export const generateBarcodesFailure = (error) => {
  return {
    type: CREATE_BARCODES_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const generateAllBarcodeImagesRequested = () => {
  return {
    type: CREATE_ALL_BARCODE_IMAGES_REQUESTED
  }
};

// Watch this watchID to check if barcodes have been generated
export const generateAllBarcodeImagesSuccess = (payload) => {
  return {
    type: CREATE_ALL_BARCODE_IMAGES_SUCCESS,
    payload: payload
  }
};

export const generateAllBarcodeImagesFailure = (error) => {
  return {
    type: CREATE_ALL_BARCODE_IMAGES_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const generateAllBarcodeValuesRequested = () => {
  return {
    type: CREATE_ALL_BARCODE_VALUES_REQUESTED
  }
};

// Watch this watchID to check if barcodes have been generated
export const generateAllBarcodeValuesSuccess = (payload) => {
  return {
    type: CREATE_ALL_BARCODE_VALUES_SUCCESS,
    payload: payload
  }
};

export const generateAllBarcodeValuesFailure = (error) => {
  return {
    type: CREATE_ALL_BARCODE_VALUES_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const refreshBatchesRequested = () => {
  return {
    type: REFRESH_BATCHES_REQUESTED
  }
};

// Watch this watchID to check if barcodes have been generated
export const refreshBatchesSuccess = (payload) => {
  return {
    type: REFRESH_BATCHES_SUCCESS,
    payload: payload
  }
};

export const refreshBatchesFailure = (error) => {
  return {
    type: REFRESH_BATCHES_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};


export const barcodeDownloadRequested = () => {
  return {
    type: DOWNLOAD_BARCODE_IMAGE_REQUESTED
  }
};

// Watch this watchID to check if barcodes have been generated
export const barcodeDownloadSuccess = (payload) => {
  return {
    type: DOWNLOAD_BARCODE_IMAGE_SUCCESS,
    payload: payload
  }
};

export const barcodeDownloadFailure = (error) => {
  return {
    type: DOWNLOAD_BARCODE_IMAGE_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const generateBarcodes = (shopUrl, payload, barcodes) => {
  return (dispatch) => {
    dispatch(generateBarcodesRequested());

    let endPoint = Config.baseUrl + Config.barcode + Config.generate;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, { 'items': barcodes } , { headers: headers })
      .then((response) => {
        dispatch(generateBarcodesSuccess(response.data));
      }).catch((error) => {
        dispatch(generateBarcodesFailure(error));
      });
  }
}

export const generateAllBarcodeImages = (shopUrl, payload) => {
  return (dispatch) => {
    dispatch(generateAllBarcodeImagesRequested());

    let endPoint = Config.baseUrl + Config.barcode + Config.generateAll;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, {} , { headers: headers })
      .then((response) => {
        dispatch(generateAllBarcodeImagesSuccess(response.data));
      }).catch((error) => {
        dispatch(generateAllBarcodeImagesFailure(error));
      });
  }
}

export const generateAllBarcodeValues = (shopUrl, payload, random, skipExisting) => {
  return (dispatch) => {
    dispatch(generateAllBarcodeValuesRequested());

    let endPoint = Config.baseUrl + Config.barcode + Config.generateValues;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, { random: random, skip_existing: skipExisting } , { headers: headers })
      .then((response) => {
        dispatch(generateAllBarcodeValuesSuccess(response.data));
      }).catch((error) => {
        dispatch(generateAllBarcodeValuesFailure(error));
      });
  }
}

export const refreshBatches = (shopUrl, payload) => {
  return (dispatch) => {
    dispatch(refreshBatchesRequested());

    let endPoint = Config.baseUrl + Config.barcode + Config.batches;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, {} , { headers: headers })
      .then((response) => {
        dispatch(refreshBatchesSuccess(response.data));
      }).catch((error) => {
        dispatch(refreshBatchesFailure(error));
      });
  }
}

export const downloadBarcodeImage = (shopUrl, payload, itemId, symbol) => {
  return (dispatch) => {
    dispatch(barcodeDownloadRequested());

    let endPoint = Config.baseUrl + Config.barcode + Config.download + '?itemId=' + itemId;

    endPoint = endPoint + '&symbol=' + symbol;

    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(barcodeDownloadSuccess(response.data));
      })
      .catch((error) => {
        dispatch(barcodeDownloadFailure(error));
      });

  }
}

